import { X_API_KEY } from "consts/env";

/**
 * Headers Hooli para requests `fetch` directo contra el SSE Manager
 * (fuera del `serviceURL` principal, por lo que no pasan por `axiosPost`).
 */
export function getStreamHeaders(credentials) {
    return {
        "X-Api-Key": X_API_KEY,
        "x-origin-id": "MIAWEBCLI",
        "Content-Type": "application/json",
        "x-hooli-token": credentials?.hooliToken || credentials?.token,
        "x-session-id": credentials?.sessionId,
    };
}
